import { Component, input, linkedSignal } from '@angular/core';

/**
 * One step of the filing flow. Collapses to its summary as soon as the step has
 * a value and opens again when that value is cleared, so the taskpane shows the
 * choices made rather than the lists they came from. The header stays clickable
 * either way, since a choice has to be changeable.
 */
@Component({
  selector: 'cmi-step-panel',
  imports: [],
  templateUrl: './step-panel.html'
})
export class StepPanel {
  public readonly title = input.required<string>();
  /** What was picked. Null keeps the panel open, since nothing is picked yet. */
  public readonly summary = input<string | null>(null);
  public readonly placeholder = input<string>('');

  protected readonly expanded = linkedSignal<string | null, boolean>({
    source: () => this.summary(),
    computation: (summary) => summary === null
  });

  protected toggle(): void {
    this.expanded.update((expanded) => !expanded);
  }
}
